module.exports = __webpack_public_path__ + "static/media/add-icon.112b5fa9.svg";